import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "Delete",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "Cancel",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "Unknown",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "測試模式",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "正式測試模式",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "此結帳處於 {mode}。實際上不會進行任何付款。",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "明白了",
};

export default LABELS;
